<template>
  <div id="creator_country_reward_record"  :class="isFull === 1 ? 'creator_country_reward_record top_information1' : ' creator_country_reward_record'">
    <van-nav-bar
        left-arrow
        placeholder
        fixed
        :title="$t('column.Reward_Claim_History')"
        @click-left="goBack"
    />
    <van-row>
      <van-col span="24">
        <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="$t('other.there_is_no_more')"
          :loading-text="$t('other.Loading')"
          @load="onLoad"
        >
          <van-cell v-for="item in list" :key="item.id">
            <van-col span="24" class="creator_country_reward_record_type">
              <van-col span="18" class="creator_country_reward_record_type_title">
                <van-col span="24" class="creator_country_reward_record_type_title_name">{{ item.reward_tier }}</van-col>
                <van-col span="24" class="creator_country_reward_record_type_title_val"> {{ $t('column.Reward_Amount') }}: {{ item.reward_amount_k }}</van-col>
              </van-col>
              <van-col span="6" class="creator_country_reward_record_type_status">
                <van-tag color="#DCFCE7" style="color: #258A4B;" v-if="item.status =='1'"> {{ $t('column.Approved') }}</van-tag>
                <van-tag color="#FEE2E2" style="color: #C13333;" v-else-if="item.status == '2'">{{ $t('column.Rejected') }}</van-tag>
                <van-tag color="#FFEDD5" style="color: #C44612" v-else>{{ $t('column.Pending_Review') }}</van-tag>
              </van-col>
              <van-col span="24" class="creator_country_reward_record_type_center">
                {{ $t('column.this_month_goal_presentation', {creator_agencies: item.creator_agencies, creator_user_per: item.creator_user_per}) }}
              </van-col>
              <van-col span="24" class="creator_country_reward_record_type_time">{{ item.applied_at }}</van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import axios from "axios";
import {Toast} from "vant";

export default {
  data() {
    return {
      isFull: 0, // is_full=1 全屏显示信号栏 0 非全屏显示信号栏
      list: [],
      loading: false,
      finished: false,
      page: 1
    }
  },
  created() {
    this.isFull = this.$route.query.is_full == 1 ? 1 : 0 // is_full=1 显示信号栏
    this.get_list()
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    get_list(){
      this.loading = true
      const token = this.$route.query.token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=creator_country&act=create_creator_country_reward", {
        params : {
          token: token,
          page: this.page
        }
      }).then(res =>{
        this.loading = false;
        if (this.page === 1) {
          this.list = []
        }
        for (let j = 0; j < res.data.data.length; j++) {
          this.list.push(res.data.data[j])
        }
        //如果列表数据条数< 0，不再触发滚动加载
        if (res.data.data.length <= 0) {
          this.finished = true
        }
        this.page ++
      })
    },
    onLoad() {
      // 异步更新数据
      if (this.page > 1){
        this.get_list()
      }
    },
  }
}
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/creator_country_reward_record.vue